import { isNullish } from '../../../Utility/Nullish';
import { ListWidgetTemplateData } from '../../../Widget/ListWidget/types';
import { VueTemplate } from '../VueTemplate';

/**
 * Template class for List widget created using Vue
 */
export class VueListTemplate extends VueTemplate<ListWidgetTemplateData> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for List must be of this format so that templates are
     * consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties: {
        list: ObjectConstructor;
        cols: ObjectConstructor;
        viewBag: ObjectConstructor;
        Zone: ObjectConstructor;
        wobj: ObjectConstructor;
        context: ObjectConstructor;
        lastUpdated: NumberConstructor;
        Widget: ObjectConstructor;
    } = {
        list: Object,
        cols: Object,
        viewBag: Object,
        Zone: Object,
        wobj: Object,
        lastUpdated: Number,
        Widget: Object,
        context: Object,
    };

    async render(context: ListWidgetTemplateData): Promise<void> {
        if (
            isNullish(context) ||
            isNullish(context.context) ||
            isNullish(context.context.widget.id)
        ) {
            throw new Error('context data missing for Vue list template');
        }
        await super.render(context);
    }
}
